export default "__VITE_ASSET__Byg3EPFd__"